export var CHIP_ENTITY_TYPE = 'CHIP';
//# sourceMappingURL=chipConstants.js.map